// extracted by mini-css-extract-plugin
module.exports = {"embedFail":"styles_embedFail__e6Rdu","embedFailParagraph":"styles_embedFailParagraph__bzaO8","embedFailTitle":"styles_embedFailTitle__w1cEL"};